import React from 'react';

export const Sparkline: React.FC<{ data: number[]; color: string; width?: number; height?: number }> = ({
  data, color, width = 100, height = 32,
}) => {
  if (data.length === 0) return null;
  const max = Math.max(...data);
  const min = Math.min(...data);
  const range = max - min || 1;
  const step = width / Math.max(data.length - 1, 1);
  const points = data.map((v, i) => `${i * step},${height - ((v - min) / range) * height}`).join(' ');
  return (
    <svg width={width} height={height} style={{ display: 'block' }}>
      <polyline points={points} fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export const MiniBarChart: React.FC<{
  data: { label: string; value: number }[];
  color?: string;
  formatValue?: (v: number) => string;
}> = ({ data, color = '#1A6CF6', formatValue }) => {
  if (data.length === 0) {
    return <p style={{ fontSize: 12, color: 'var(--nx-text-muted)' }}>No data yet.</p>;
  }
  const max = Math.max(...data.map(d => d.value), 1);
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      {data.map(d => (
        <div key={d.label} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <span style={{ fontSize: 11, color: 'var(--nx-text-secondary)', width: 110, flexShrink: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {d.label}
          </span>
          <div style={{ flex: 1, background: 'var(--nx-surface-3)', borderRadius: 6, height: 10, overflow: 'hidden' }}>
            <div style={{ width: `${(d.value / max) * 100}%`, height: '100%', background: color, borderRadius: 6 }} />
          </div>
          <span style={{ fontSize: 11, color: 'var(--nx-text-muted)', width: 70, textAlign: 'right', flexShrink: 0 }}>
            {formatValue ? formatValue(d.value) : d.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export const StatTile: React.FC<{ label: string; value: string; sub?: string; accent?: string }> = ({
  label, value, sub, accent = '#1A6CF6',
}) => (
  <div style={{
    background: 'var(--nx-surface-1)', border: '1px solid var(--nx-border)', borderRadius: 12,
    padding: '16px 18px', flex: 1, minWidth: 160,
  }}>
    <p style={{ fontSize: 11, fontWeight: 600, color: 'var(--nx-text-muted)', textTransform: 'uppercase', letterSpacing: '0.05em', marginBottom: 8 }}>
      {label}
    </p>
    <p style={{ fontFamily: 'Syne, sans-serif', fontSize: 22, fontWeight: 700, color: accent }}>{value}</p>
    {sub && <p style={{ fontSize: 11, color: 'var(--nx-text-muted)', marginTop: 4 }}>{sub}</p>}
  </div>
);
